import React from 'react';
import { Link } from 'react-router-dom';
import './main.css';
import schLogo from '../common/images/SCH_logo.svg'
/*import cglLogo from '../common/images/cg_logo.png'*/

interface MenuItem {
  label: string;
  link: string;
  subMenuItems?: MenuItem[];
}

interface HeaderProps {
  menuItems: MenuItem[];  
}

const Header: React.FC<HeaderProps> = ({ menuItems }) => {
  return (
    <div id="header-wrapper">
      <header id="header" className="container">
        {/* Logo */}
        <div id="logo">
          <h1>
            <Link to="/">
            <img src={schLogo} alt="SchLogo" style={{ width: '100px', height: 'auto', verticalAlign: 'middle' }}/>           
            <span style={{marginLeft: '15px'}}>CGLAB</span>
            </Link>
            
          </h1> {/* Link 컴포넌트로 홈 링크 설정 */}
        </div>        
        <div>
        {/* Nav */}
        <nav id="nav">
          <ul>
            {menuItems.map((menuItem) => (
              <li key={menuItem.label}>
                <Link to={menuItem.link}>{menuItem.label}</Link> {/* Link 컴포넌트로 메뉴 링크 설정 */}
                {menuItem.subMenuItems && (
                  <ul>
                    {menuItem.subMenuItems.map((subMenuItem) => (
                      <li key={subMenuItem.label}>
                        <Link to={subMenuItem.link}>{subMenuItem.label}</Link> {/* Link 컴포넌트로 서브 메뉴 링크 설정 */}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>
        </div>
      </header>
    </div>
  );
};

export default Header;
